module.exports = __webpack_public_path__ + "img/sup_deposit_bank2.3393a6cb.jpg";